/**
 * Floor Image Component - Renders a single floor image
 */

import { __ } from '@wordpress/i18n';

const FloorImage = ({ floorId, floorPost }) => {
    if (!floorPost || !floorPost.image) {
        return null;
    }

    return (
        <div className="floor-item" data-floor-id={floorId}>
            <div className="floor-image">
                <img
                    src={floorPost.image}
                    alt={floorPost.title || __('Floor Image')}
                    style={{ maxWidth: '100%', height: 'auto', display: 'block' }}
                />
            </div>
        </div>
    );
};

export default FloorImage;
